import React, { useState, useImperativeHandle } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleUp } from "@fortawesome/free-solid-svg-icons"
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import { TABLE_DATA } from "util";
import update from 'immutability-helper'
import Rows from "./DnDTables/DataTable";
import { useTranslation } from 'react-i18next'
import { initialData_comp as initialData} from "./TableDataSet";

const P_TYPE = "composition";
const API = "";

//const initialData = TABLE_DATA[P_TYPE].filter((t) => !(t.name === "rcvCopy" || t.type === "hidden"));

const COMTable = (props, _ref) => {
    const { t } = useTranslation(['page']);
    const { PROCode, unitCd, onOpen,RevCmptCheckList } = props;

    const [Hide, setHide] = useState(false);
    const [TData, setTData] = useState([]);

    useImperativeHandle(_ref, () => ({
        getTableData: () => {
            return TData;
        },
        initial: () => {
            setTData(TD => []);
        },
        add: () => {
            // setTData(TP => update(TP, {
            //     $push: [initialData]
            // }))
        },
        move: ({ dragIndex, hoverIndex }) => {
            // setTData(TP => update(TP, {
            //     $splice: [
            //         [dragIndex, 1],
            //         [hoverIndex, 0, TP[dragIndex]],
            //     ]
            // }))
        },
        remove: (idx) => {
            // setTData(TP => update(TP, {
            //     $splice: [[idx, 1]]
            // }));
        },
        loadData: (data) => {
            let newVal = [];
            let tmp;
            let fidx;
            data.map(d => {
                tmp = initialData;
                Object.keys(d).map(k => {
                    fidx = tmp.findIndex(i => i.name === k);
                    if (fidx > -1) tmp = update(tmp, {
                        [fidx]: { $merge: { value: d[k] } }
                    })
                })
                newVal = [...newVal, [...tmp]]
            })
            setTData(newVal);
        }
    }))

    // urs 63 : 카피기능 추가 (카피 안되는 현상 해결
    const copyRow = (code, index) => {
        
        const newArr = [...TData[index]].map(f => {
            if(f.name === "uniqueCode") {
                f.value = "";
            }
            return f;
        })
        setTData((TP) =>
            update(TP, {
                 $push: [newArr] 
            })
        );
    };
    // urs 63 카피 끝
    const onOpenWrapper = (vv,uniqueCode) => {
        onOpen(vv,uniqueCode,TData,'COM');
    }
    const HandleHide = () => {
        setHide(!Hide);
    }

    const renderFunc = () => {

        try {
            return TData.map((v, i) => {                
                return <Rows
                    api={API}
                    // code={k.tempUniqCode}
                    copied={copyRow}
                    PROCode={PROCode}
                    index={i}
                    rowData={v}
                    // moveRow={moveRow}
                    // changed={changeRow}
                    // deleted={deleteRow}
                    key={"comp" + i}
                    onOpen = {onOpenWrapper}
                    RevCmptCheckList={RevCmptCheckList}
                />
            })
        } catch (e) {
            return null;
        }
    }

    return unitCd?.match(/(USP01|DSP01|USP06|DSP07)/) !== null &&
    // return false && 
        <section className="detail" style={{width: "initial"}}>
        <div className={"in_table tbl_box " + (Hide ? "hide" : "")}>
            <h1 className={"title "} onClick={HandleHide}>{P_TYPE.toUpperCase()} <FontAwesomeIcon icon={faAngleUp} /></h1>
            <div className={"data_table "}>
                <DndProvider backend={HTML5Backend}>
                    <table>
                        <colgroup>
                            <col width="2%"></col>
                            {/* <col width="10%"></col> */}
                            <col width="10%"></col>
                            <col width="10%"></col>
                            <col width="10%"></col>
                            <col width="10%"></col>
                            <col width="2%"></col>
                            <col width="0.5%"></col>
                            <col width="2%"></col>
                            <col width="12%"></col>
                            {/* <col width="2%"></col>
                            <col width="1%"></col> */}
                        </colgroup>
                        <thead>
                            <tr>
                                <th></th>
                                {/* <th>Parameter Code</th> */}
                                <th>Material Code</th>
                                <th>Component</th>
                                <th>Main/Alter</th>
                                <th>Concentration</th>
                                <th colSpan="3">Unit</th>
                                <th>Reference</th>
                                {/* <th>Remark</th> */}
                            </tr>

                        </thead>
                        <tbody>
                            {renderFunc()}
                        </tbody>
                        {/* <tfoot>
                            {
                                <tr className="add_param" onClick={addRow}>
                                    <td colSpan={Object.keys(initialData).length + 1}>+Add Parameter</td>
                                </tr>
                            }

                        </tfoot> */}
                    </table>
                </DndProvider>
            </div>
        </div>
    </section>
}

export default React.memo(React.forwardRef(COMTable));